/**
 * Created by M on 2018/3/29.
 */
import fpToolbar from './Toolbar.vue'
export default {
  props: {
    actions: {
      type: Array,
      default: function () {
        return []
      }
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    backButtonClick: {
      type: Function
    }
  },
  components: {
    'lms-toolbar': fpToolbar
  },
  methods: {
    handleClick(actionId) {
      this.$emit('toolbarClick', actionId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/basicElement/layout/subLayout.js